import { AutoLockFormsLevelType } from '../autoLockForms.constants';

export const addressFormFields = [
  {
    name: 'isOutsideUsa',
    label: 'Outside USA',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'street',
    label: 'Street',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'unit',
    label: 'Unit',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'city',
    label: 'City',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'county',
    label: 'County',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'state',
    label: 'State',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'zip',
    label: 'Zip',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'country',
    label: 'Country',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'censusTract',
    label: 'Census Tract',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];
